module.exports = __webpack_public_path__ + "static/notice-title-do-1af3ac2c2a68a381940f42d0779db450.png";